import * as React from 'react';
import { useRecoilValueLoadable } from 'recoil';
import { accountDetailsSelector } from 'common/state/account';
import { useRefetchAccountDetails } from 'common/hooks/account';

const REFRESH_INTERVAL_MS = 60000;

export const useRefreshAccountDetails = (): void => {
  const accountDetails = useRecoilValueLoadable(accountDetailsSelector);
  const { refetchAccountDetails } = useRefetchAccountDetails();

  React.useEffect(() => {
    if (accountDetails.state !== 'hasValue' || !accountDetails.contents?.features) return;

    const refreshAccountDetailsWithoutInterrupting = () => {
      refetchAccountDetails().catch(() => null);
    };

    window.addEventListener('focus', refreshAccountDetailsWithoutInterrupting);
    const intervalId = window.setInterval(refreshAccountDetailsWithoutInterrupting, REFRESH_INTERVAL_MS);

    return () => {
      window.removeEventListener('focus', refreshAccountDetailsWithoutInterrupting);
      window.clearInterval(intervalId);
    };
  }, [accountDetails.contents?.features, accountDetails.state, refetchAccountDetails]);
};
